var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-form-block',{attrs:{"button-text":_vm.$t('Run'),"fields":_vm.fields,"on-submit":_vm.onSubmitForm}})}
var staticRenderFns = []

export { render, staticRenderFns }